if (!window.kareliaQuantityDiscountSelectorInitialized) {
  window.kareliaQuantityDiscountSelectorInitialized = true;

  const formatMoney = (amount, moneyFormat) => {
    const number = (amount / 100).toFixed(2);
    const amountWithCommaSeparator = number.replace('.', ',');
    const amountWithApostropheSeparator = number.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    const amountWithSpaceSeparator = number.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const amountNoDecimals = Math.round(amount / 100).toString();
    const amountNoDecimalsWithCommaSeparator = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const amountNoDecimalsWithSpaceSeparator = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const format = moneyFormat || '€{{amount_with_comma_separator}} EUR';

    return format
      .replace('{{amount_with_comma_separator}}', amountWithCommaSeparator)
      .replace('{{amount_with_apostrophe_separator}}', amountWithApostropheSeparator)
      .replace('{{amount_with_space_separator}}', amountWithSpaceSeparator)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithCommaSeparator)
      .replace('{{amount_no_decimals_with_space_separator}}', amountNoDecimalsWithSpaceSeparator)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', number.replace('.', ','));
  };

  const updateDisplayedPrice = (selector, option) => {
    const priceContainer = document.getElementById(selector?.dataset.priceTarget);
    const unitPrice = Number(selector?.dataset.unitPrice || 0);
    const unitCompareAtPrice = Number(selector?.dataset.unitCompareAtPrice || unitPrice);
    const quantity = Number(option.value || 0);
    const fixedDiscount = Math.round(Number(option.dataset.fixedDiscount || 0) * 100);

    if (!priceContainer || !unitPrice || !quantity) return;

    const price = Math.max(0, unitPrice * quantity - fixedDiscount);
    const compareAtPrice = unitCompareAtPrice * quantity;
    const discountPercentage = compareAtPrice > price
      ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
      : 0;
    const salePrice = priceContainer.querySelector('.price__sale .price-item--sale');
    let discountBadge = priceContainer.querySelector('[data-quantity-discount-badge]');

    priceContainer.classList.add('karelia-quantity-discount-price');

    if (!discountBadge && salePrice) {
      discountBadge = document.createElement('span');
      discountBadge.className = 'karelia-quantity-discount-badge';
      discountBadge.dataset.quantityDiscountBadge = '';
      salePrice.before(discountBadge);
    }

    if (discountBadge) {
      discountBadge.hidden = discountPercentage <= 0;
      discountBadge.textContent = discountPercentage > 0 ? `-${discountPercentage}%` : '';
    }

    priceContainer.querySelectorAll('.price-item--sale').forEach((element) => {
      element.textContent = formatMoney(price, selector.dataset.moneyFormat);
    });

    priceContainer.querySelectorAll('.price__sale .price-item--regular').forEach((element) => {
      element.textContent = formatMoney(compareAtPrice, selector.dataset.moneyFormat);
    });
  };

  const updateQuantity = (option) => {
    const selector = option.closest('[data-quantity-discount-selector]');
    const quantityInput = document.getElementById(selector?.dataset.quantityTarget);
    if (!quantityInput) return;

    quantityInput.value = option.value;
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateDisplayedPrice(selector, option);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-quantity-discount-option]')) updateQuantity(event.target);
  });

  document.addEventListener('click', (event) => {
    const label = event.target.closest('[data-quantity-discount-selector] label');
    const option = label ? document.getElementById(label.htmlFor) : null;
    if (option?.matches('[data-quantity-discount-option]')) updateQuantity(option);
  });

  const syncInitialSelections = () => {
    document.querySelectorAll('[data-quantity-discount-selector]').forEach((selector) => {
      const selectedOption = selector.querySelector('[data-quantity-discount-option]:checked');
      if (selectedOption) updateDisplayedPrice(selector, selectedOption);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncInitialSelections);
  } else {
    syncInitialSelections();
  }
}
